// isModifiedFromDefault — rule for Modified pill (D-58)
// VoiceSpectrum.Web.T2 · v10.0.8.5 · 2026-05-17 · VoiceSpectrum AI

/**
 * Returns true when the current value differs from the pack default,
 * meaning the Modified pill should be shown.
 *
 * Comparison is string-trim-based for text fields.
 * For objects/arrays, uses JSON.stringify for deep comparison.
 */
export function isModifiedFromDefault(
  value: unknown,
  defaultValue: unknown,
): boolean {
  if (value === defaultValue) return false;

  if (typeof value === 'string' && typeof defaultValue === 'string') {
    return value.trim() !== defaultValue.trim();
  }

  // Deep comparison via JSON serialization (canonical approach per impl spec)
  try {
    return JSON.stringify(value) !== JSON.stringify(defaultValue);
  } catch {
    return value !== defaultValue;
  }
}

/**
 * Convenience: check a per-language text field against its pack default.
 */
export function isLangFieldModified(
  fields: Record<string, string> | undefined,
  packDefault: Record<string, string> | undefined,
  lang: string,
): boolean {
  const current = fields?.[lang] ?? '';
  const def = packDefault?.[lang] ?? '';
  return isModifiedFromDefault(current, def);
}
